/**
 * AI Traffic constants and JSDoc shapes (mirrors frontend/src/api/monitoring.ts §9).
 * Backend MS1 actions proxy to gateway REST — see monitoringApi.js.
 */

/**
 * Site-scoped AI Traffic requests send only numeric `websiteId` in the POST body.
 * MS1 resolves organisation + gateway website pair server-side.
 */
export const SOURCE_LABELS = {
	ga4: "GA4",
	cloudflare: "Cloudflare",
	native: "Native",
	gsc: "GSC",
	bing: "Bing",
};

export const SUB_TABS = [
	{ key: "summary", label: "Summary" },
	{ key: "crawlers", label: "Crawlers" },
	{ key: "referrals", label: "Referrals" },
	{ key: "search", label: "Search" },
	{ key: "trace", label: "Traceability" },
];

export const INLINE_ROWS = 20;

export const SEARCH_ENGINES = [
	{ key: "gsc", label: "Google" },
	{ key: "bing", label: "Bing" },
];

export const SEARCH_SURFACES = [
	{ key: "web", label: "Web" },
	{ key: "discover", label: "Discover" },
	{ key: "news", label: "News" },
];

export const STATUS_DISTRIBUTION_ROWS = [
	["ok", "200 OK", "monitoring__ai-traffic-status-bar-fill--ok"],
	["redirect", "3xx Redirect", "monitoring__ai-traffic-status-bar-fill--redirect"],
	["not_found", "404 Not Found", "monitoring__ai-traffic-status-bar-fill--not-found"],
	["client_error", "Other 4xx (incl. 403/429)", "monitoring__ai-traffic-status-bar-fill--client-error"],
	["server_error", "5xx Server Error", "monitoring__ai-traffic-status-bar-fill--server-error"],
];

export const CAPABILITY_LABELS = {
	ai_referrals: "AI referral visits",
	ai_referral_pages: "Referral landing pages",
	engagement: "Engagement",
	conversions: "Conversions & revenue",
	ai_bot_crawls: "AI bot crawls",
	bot_status_codes: "Bot status codes (404s)",
	crawl_urls: "Per-URL crawl detail",
	verified_bots: "Verified bots",
};

export const CONNECTOR_STATUS_LABELS = {
	active: "Connected",
	needs_auth: "Needs authorisation",
	error: "Error",
	revoked: "Disconnected",
};

export const VERDICT_ORDER = ["PASS", "NEUTRAL", "FAIL", "UNKNOWN"];

export const VERDICT_LABEL = {
	PASS: "PASS — indexed",
	NEUTRAL: "NEUTRAL — excluded by design",
	FAIL: "FAIL — not indexed",
	UNKNOWN: "UNKNOWN",
};

export const VERDICT_TONE = {
	PASS: "monitoring__ai-traffic-status-bar-fill--ok",
	NEUTRAL: "monitoring__ai-traffic-status-bar-fill--neutral",
	FAIL: "monitoring__ai-traffic-status-bar-fill--server-error",
	UNKNOWN: "monitoring__ai-traffic-status-bar-fill--neutral",
};

/**
 * MS1 action → gateway REST mapping (for backend implementers):
 *
 * aiVisibilityMonitoringTraffic          → GET  /monitoring/project/traffic
 * aiVisibilityMonitoringTrafficSync      → POST /monitoring/project/traffic/sync
 * aiVisibilityMonitoringTrafficBounds    → GET  /monitoring/project/traffic/bounds
 * aiVisibilityMonitoringTrafficCoverage  → GET  /monitoring/project/traffic/coverage
 * aiVisibilityMonitoringSearch           → GET  /monitoring/project/search
 * aiVisibilityMonitoringSearchSync       → POST /monitoring/project/search/sync
 * aiVisibilityMonitoringTraceability     → GET  /monitoring/project/search/traceability
 * aiVisibilityMonitoringSearchInspect    → POST /monitoring/project/search/inspect
 * aiVisibilityMonitoringConnectors       → GET  /connectors
 * aiVisibilityMonitoringConnections      → GET  /connections
 * aiVisibilityMonitoringCreateConnection → POST /connections
 * aiVisibilityMonitoringVerifyConnection → POST /connections/{id}/verify
 * aiVisibilityMonitoringReconnectConnection → POST /connections/{id}/reconnect
 * aiVisibilityMonitoringRotateConnection → POST /connections/{id}/rotate
 * aiVisibilityMonitoringDeleteConnection → DELETE /connections/{id}
 */
